import React from 'react';
import PropTypes from 'prop-types';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { Image } from 'site-modules/shared/components/image/image';
import { Link } from 'site-modules/shared/components/link/link';
import { SOURCES, getStaticImageUrl } from 'client/utils/image-helpers';
import { NO_VEHICLE_GRAY_IMAGE_SEDAN } from 'site-modules/shared/constants/images';

import './national-sales-list.scss';

function NationalSalesCard({ image = '', link = '', text = '', vehicleName = '', id = '' }) {
  const position = id.split('-')[1];
  const errorImage = getStaticImageUrl(NO_VEHICLE_GRAY_IMAGE_SEDAN);

  return (
    <li className="national-sales-card mb-1">
      <h2 className="size-16">
        {position}. <Link to={link}>{vehicleName}</Link>
      </h2>
      <Row>
        <Col xs={4}>
          <Image
            imageId={image}
            source={SOURCES.DAM}
            className="img-fluid rounded"
            alt={vehicleName}
            width={300}
            errorImage={errorImage}
          />
        </Col>
        <Col xs={8}>
          <p className="size-16">{text}</p>
        </Col>
      </Row>
    </li>
  );
}

NationalSalesCard.propTypes = {
  image: PropTypes.string,
  link: PropTypes.string,
  text: PropTypes.string,
  vehicleName: PropTypes.string,
  id: PropTypes.string,
};

export function NationalSalesList({ title = 'National sales', vehiclesList = [] }) {
  return (
    <section className="national-sales-list">
      <h2 className="heading-3 mb-1_5">{title}</h2>
      <ol className="cards-list list-unstyled mb-0">
        {vehiclesList.map(vehicle => (
          <NationalSalesCard key={vehicle.id} {...vehicle} />
        ))}
      </ol>
    </section>
  );
}

NationalSalesList.propTypes = {
  title: PropTypes.string,
  vehiclesList: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string,
      link: PropTypes.string,
      linktext: PropTypes.string,
      text: PropTypes.string,
      vehicleName: PropTypes.string,
      id: PropTypes.string,
    })
  ),
};
